 
var finnn = {
  all_option: function(){ 
      $('.ictxt_item').mouseenter(function(){
        var id = $(this).data('id');
        $('.ictxt_item, .ictxt_bottom').removeClass('active');
        $(this).addClass('active');
        $('.ictxt_bottom[data-id="'+id+'"]').addClass('active'); 
    }); 

    // menu
    $('.menu-drawer__close-button').on('click', function(){
        $(this).closest('details').removeAttr('open');
    });

    
  //faq
      $('.inner_box_faq .q_heading').click(function(){
        
        if(!$(this).hasClass('active'))
        {
        
      		 $(this).parent('.inner_box_faq').parent('.faq_section_box').children('.inner_box_faq').each(function(){
                if( $(this).children('.q_heading').hasClass('active')  )
                   {
    					$(this).children('.q_heading').next('.q_asked').slideToggle();
                        $(this).children('.q_heading').removeClass('active');
                   }
                });
        
        	$(this).addClass('active');
        	$(this).next('.q_asked').slideToggle();
        }else{
            $(this).removeClass('active');
        	$(this).next('.q_asked').slideToggle();
          }
      });
  },
  bird_house: function(){
    birdhouse_slider();
    $('.bh-quAns').click(function(){ 
       if(!$(this).hasClass('active'))
        { 
      		 $(this).parent('.bh_faq_section').children('.bh-quAns').each(function(){
                if( $(this).hasClass('active')  )
                   {
    					$(this).find('.bh-answer').slideToggle();
                        $(this).removeClass('active');
                   }
                });
        
        	$(this).addClass('active');
        	$(this).find('.bh-answer').slideToggle();
        }else{
            $(this).removeClass('active');
        	$(this).find('.bh-answer').slideToggle();
          } 
    });

    function birdhouse_slider(){
        if($(window).width() > 769)
        {
      	var r_w = $('.review-txt .review-txt-box').width();   
          $('.review-txt .review-txt-box-inner').css('height', r_w+'px');
        }
        else
        {
          $('.review-txt .review-txt-box-inner').removeAttr('style');
        }
      }
  },
  product_page: function() {
    
    $('.prod-title').on(function() {
        $(this).toggleClass('active');
       $(this).next('.product-single__description').sliderToggle();
    });
    
  },
  search_option: function(){
    
    $('form.custom_search').on('submit', function(e){
      e.preventDefault();
      var serch_value = $(this).find('.search_value').val();
      
      $('.blog_posts').html('');
      $('.pagination').hide();
      
        $.each(search_array, function(key, val){
         
          if(typeof val.title !== 'undefined' && serch_value != ''){
             var title = val.title.toLowerCase();
            serch_value = serch_value.toLowerCase();
            
            var description = val.description;;
            if (description.length > 1) {
              description = description.toLowerCase();
            }
            
            if(title.indexOf(serch_value) > -1 ) {
               add_html(val);
            }else if( description.indexOf(serch_value) > -1){
              add_html(val);
            }
          }
      });
      
      
    });
    
    
    function add_html(value){
      
      var html = '<div class="custome-blog   ajax_loading"> <div class="article--listing">';
      
      		if(typeof value.img !== 'undefined') { 
              html +='<div  class="article__list-image-wrapper js">'+
                     '<a href="'+value.url+'" class="article__list-image-container">'+
                      '<img class="article__list-image lazyautosizes lazyloaded" src="'+value.img+'" alt="'+value.title+'"/>'+
                    '</a>'+
                    
                    '<div class="btn_read_more">'+
                       '<div class="btn_read_more_inner">'+
                        '<a href="'+value.url+'"> Read more </a>'+
                     ' </div>'+
                    '</div>'+                    
                  '</div>';
            }
     		 if(typeof value.title !== 'undefined') { 
               html += '<div class="article__title h3">'+	
                    	 '<a href="'+value.url+'">'+value.title+'</a>'+
                  	   '</div>';
                }
            if(value.short_description != '') { 
               html += '<div class="article-card__excerpt">'+value.short_description+'</div>';
            }else if(typeof value.description !== 'undefined'){
              var description = value.description;
              if (description.length > 100) {
                description =description.substr(0, description.lastIndexOf(' ', 97)) + '...';
              }
              
              html += '<div class="article-card__excerpt">'+description+'</div>';
            }
      
      
          		 '</div></div>';
      
       $('.blog_posts').append(html);
      
    }
    
    
  }
}

jQuery(function($){
    finnn.all_option();
    finnn.bird_house();
    finnn.product_page();
    finnn.search_option();
});